export default __webpack_public_path__ + "static/media/landscaping-4.caafa998.webp";